var _defs, _path, _path2, _circle, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFlujoIniciado = function SvgFlujoIniciado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50%",
    height: "50%",
    preserveAspectRatio: "xMinYMin meet",
    id: "flujo-iniciado_svg__Ilustraci\\xF3n",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513.83 335.96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".flujo-iniciado_svg__cls-1{fill:#ccc}.flujo-iniciado_svg__cls-2{fill:#0b66c9}.flujo-iniciado_svg__cls-5{fill:#feb8b8}.flujo-iniciado_svg__cls-6{fill:#2f2e41}.flujo-iniciado_svg__cls-7{fill:#e6e6e6}.flujo-iniciado_svg__cls-8{fill:#f2f2f2}"))), /*#__PURE__*/React.createElement("g", {
    id: "flujo-iniciado_svg__Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flujo-iniciado_svg__Group_43",
    "data-name": "Group 43"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Rectangle_113",
    "data-name": "Rectangle 113",
    className: "flujo-iniciado_svg__cls-1",
    d: "M246.62 22.17h56.79v1.08h-56.79z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Rectangle_114",
    "data-name": "Rectangle 114",
    className: "flujo-iniciado_svg__cls-1",
    d: "M22.17 22.17h180.09v1.08H22.17z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "flujo-iniciado_svg__Ellipse_115",
    "data-name": "Ellipse 115",
    className: "flujo-iniciado_svg__cls-2",
    cx: 22.17,
    cy: 22.71,
    r: 22.17
  })), /*#__PURE__*/React.createElement("circle", {
    id: "flujo-iniciado_svg__Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 123.31,
    cy: 22.71,
    r: 22.17,
    style: {
      fill: "#00c8dc"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_748-1261",
    "data-name": "Path 748-1261",
    className: "flujo-iniciado_svg__cls-1",
    d: "M224.44 45.43a22.72 22.72 0 1 1 22.71-22.72 22.72 22.72 0 0 1-22.71 22.72Zm0-44.35a21.64 21.64 0 1 0 21.63 21.63 21.63 21.63 0 0 0-21.63-21.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_749-1262",
    "data-name": "Path 749-1262",
    className: "flujo-iniciado_svg__cls-1",
    d: "M325.57 45.43a22.72 22.72 0 1 1 22.72-22.72 22.72 22.72 0 0 1-22.72 22.72Zm0-44.35a21.64 21.64 0 1 0 21.64 21.63 21.64 21.64 0 0 0-21.64-21.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_395-1263",
    "data-name": "Path 395-1263",
    d: "M20.47 29.33a1.82 1.82 0 0 1-1.08-.33l-4.09-3.16A1.81 1.81 0 1 1 17.5 23l2.63 2 6.23-8.13a1.81 1.81 0 0 1 2.54-.33 1.8 1.8 0 0 1 .33 2.53l-7.32 9.56a1.84 1.84 0 0 1-1.44.7Z",
    style: {
      fill: "#fff"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flujo-iniciado_svg__Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_552-1264",
    "data-name": "Path 552-1264",
    className: "flujo-iniciado_svg__cls-5",
    d: "M394 117.58a9.22 9.22 0 0 1 1.19.66L433 102.07l1.35-10 15.15-.1-.9 22.9-50 13.23c-.11.34-.24.68-.38 1a8.65 8.65 0 1 1-4.22-11.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_553-1265",
    "data-name": "Path 553-1265",
    className: "flujo-iniciado_svg__cls-5",
    d: "M455 325h-10.33l-4.92-39.95H455Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_554-1266",
    "data-name": "Path 554-1266",
    className: "flujo-iniciado_svg__cls-6",
    d: "M437.28 322.07h20v12.58H424.7a12.58 12.58 0 0 1 12.58-12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_555-1267",
    "data-name": "Path 555-1267",
    className: "flujo-iniciado_svg__cls-5",
    d: "m495.31 322.11-10.3 1-8.82-39.27 15.21-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_556-1268",
    "data-name": "Path 556-1268",
    className: "flujo-iniciado_svg__cls-6",
    d: "m477.35 320.9 19.87-1.9 1.23 12.51-32.38 3.19a12.58 12.58 0 0 1 11.28-13.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "flujo-iniciado_svg__Ellipse_84",
    "data-name": "Ellipse 84",
    className: "flujo-iniciado_svg__cls-5",
    cx: 457.91,
    cy: 28.96,
    r: 20.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_557-1269",
    "data-name": "Path 557-1269",
    className: "flujo-iniciado_svg__cls-6",
    d: "M442.36 317a3.77 3.77 0 0 1-3.73-3.12c-5.36-29.76-22.89-127.07-23.31-129.76v-7.45a1.21 1.21 0 0 1 .24-.73l2.31-3.24a1.22 1.22 0 0 1 1-.53c13.2-.62 56.42-2.43 58.51.17 2.09 2.62 1.35 10.57 1.18 12.14v.16L498 308.78a3.82 3.82 0 0 1-3.14 4.34l-12.13 2a3.83 3.83 0 0 1-4.25-2.61c-3.75-12-16.32-52.31-20.68-67.91a.43.43 0 0 0-.51-.32.41.41 0 0 0-.32.44c.21 14.87.74 52.82.93 65.93v1.41a3.83 3.83 0 0 1-3.46 3.83l-11.7 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_99-1270",
    "data-name": "Path 99-1270",
    className: "flujo-iniciado_svg__cls-7",
    d: "M444.75 57.87C441.12 60 439 64 437.71 68a96.2 96.2 0 0 0-4.12 23l-1.32 23.31L416 176.09c14.1 11.93 22.23 9.22 41.21-.54s21.15 3.25 21.15 3.25l3.79-52.6 5.42-57.47a25.13 25.13 0 0 0-4.1-4 42 42 0 0 0-35.86-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_558-1271",
    "data-name": "Path 558-1271",
    className: "flujo-iniciado_svg__cls-5",
    d: "M439.46 130.06a8.6 8.6 0 0 1 1.27.59l37.47-18.75.62-10.16 15.45-1.07.83 23.16-50.1 16.56a8.87 8.87 0 1 1-6.63-10.65 7.63 7.63 0 0 1 1.06.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_101-1272",
    "data-name": "Path 101-1272",
    className: "flujo-iniciado_svg__cls-7",
    d: "M487.31 69c9.22 3.25 10.85 38.5 10.85 38.5-10.85-6-23.86 3.8-23.86 3.8s-2.71-9.22-6-21.15a20.71 20.71 0 0 1 4.34-19.52s5.45-4.9 14.67-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_102-1273",
    "data-name": "Path 102-1273",
    className: "flujo-iniciado_svg__cls-6",
    d: "M476.52 34.45c-2.59-2.07-6.12 1.69-6.12 1.69l-2.06-18.61s-12.93 1.55-21.2-.52-9.57 7.5-9.57 7.5a66.46 66.46 0 0 1-.26-11.63c.52-4.66 7.24-9.31 19.13-12.41s18.1 10.34 18.1 10.34c8.28 4.13 4.56 25.71 1.98 23.64Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Rectangle_110",
    "data-name": "Rectangle 110",
    className: "flujo-iniciado_svg__cls-7",
    d: "M71.4 334.65h442.43v1.31H71.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_438-1274",
    "data-name": "Path 438-1274",
    className: "flujo-iniciado_svg__cls-7",
    d: "M114.08 311.45a11.68 11.68 0 0 0 11.28-2c4-3.32 5.2-8.78 6.2-13.84l3-15-6.26 4.39c-4.49 3.09-9.08 6.28-12.19 10.76s-4.46 10.59-2 15.43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_439-1275",
    "data-name": "Path 439-1275",
    className: "flujo-iniciado_svg__cls-8",
    d: "M115.05 330.61c-.79-5.73-1.6-11.53-1-17.31a27.28 27.28 0 0 1 5.2-14.3 24.09 24.09 0 0 1 6.09-5.52c.61-.38 1.17.59.57 1a22.49 22.49 0 0 0-8.91 10.76c-2 4.95-2.26 10.34-1.92 15.59.2 3.17.63 6.33 1.06 9.48a.58.58 0 0 1-.39.69.57.57 0 0 1-.69-.39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_442-1276",
    "data-name": "Path 442-1276",
    className: "flujo-iniciado_svg__cls-7",
    d: "M120.7 321.42a8.6 8.6 0 0 0 7.5 3.87c3.79-.18 7-2.83 9.8-5.34l8.42-7.44-5.57-.26c-4-.19-8.12-.37-11.94.86s-7.34 4.21-8 8.16"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_443-1277",
    "data-name": "Path 443-1277",
    className: "flujo-iniciado_svg__cls-8",
    d: "M112.82 333.9c3.78-6.69 8.17-14.13 16-16.51a17.86 17.86 0 0 1 6.74-.7c.71.06.54 1.17-.18 1.1a16.62 16.62 0 0 0-10.75 2.85 27.79 27.79 0 0 0-7.38 8c-1.23 1.86-2.32 3.8-3.42 5.74-.34.62-1.36.15-1.01-.48Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "flujo-iniciado_svg__Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_138-1278",
    "data-name": "Path 138-1278",
    className: "flujo-iniciado_svg__cls-7",
    d: "M379.45 140.76H190a3.51 3.51 0 0 1-3.51-3.51v-47a3.51 3.51 0 0 1 3.51-3.49h189.45a3.51 3.51 0 0 1 3.55 3.51v47a3.51 3.51 0 0 1-3.55 3.49ZM190 88.16a2.11 2.11 0 0 0-2.11 2.11v47a2.12 2.12 0 0 0 2.11 2.11h189.45a2.12 2.12 0 0 0 2.11-2.11v-47a2.11 2.11 0 0 0-2.11-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_139-1279",
    "data-name": "Path 139-1279",
    className: "flujo-iniciado_svg__cls-7",
    d: "M252.47 102.43a2.38 2.38 0 1 0 0 4.76h112.26a2.38 2.38 0 0 0 0-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_140-1280",
    "data-name": "Path 140-1280",
    className: "flujo-iniciado_svg__cls-7",
    d: "M252.47 116.72a2.38 2.38 0 1 0 0 4.76h48.32a2.38 2.38 0 1 0 0-4.76h-48.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flujo-iniciado_svg__Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "flujo-iniciado_svg__Ellipse_18",
    "data-name": "Ellipse 18",
    className: "flujo-iniciado_svg__cls-7",
    cx: 219.6,
    cy: 111.85,
    r: 14.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "flujo-iniciado_svg__Path_395-2-1281",
    "data-name": "Path 395-2-1281",
    className: "flujo-iniciado_svg__cls-2",
    d: "M217.36 119.79a2.2 2.2 0 0 1-1.33-.45l-5-3.84a2.23 2.23 0 1 1 2.67-3.5l3.25 2.49 7.67-10a2.24 2.24 0 0 1 3.13-.42l-.05.07.05-.07a2.24 2.24 0 0 1 .41 3.13l-9 11.78a2.23 2.23 0 0 1-1.77.87Z"
  }))))));
};

export default SvgFlujoIniciado;